import WebFont from 'webfontloader';
import styled from 'styled-components';
WebFont.load({
    google: {
        families: ['Poppins:300,400,500,600&display=swap'],
    },
});
const StyledBox = styled.div `
  font-family: 'Poppins', sans-serif;
  font-weight: ${({ weight }) => {
    switch (weight) {
        case 'light':
            return 300;
        case 'normal':
            return 400;
        case 'semibold':
            return 500;
        case 'bold':
            return 600;
        default:
            return 400;
    }
}};

  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  padding-left: ${({ paddingLeft }) => paddingLeft || '0'};
  padding-right: ${({ paddingRight }) => paddingRight || '0'};
  padding-top: ${({ paddingTop }) => paddingTop || '0'};
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '0'};
`;
export default StyledBox;
//# sourceMappingURL=styled.js.map